// extracted by mini-css-extract-plugin
module.exports = {"container":"MonthlyConsumption_container__3q7tT","title":"MonthlyConsumption_title__2sxDq"};